import React from "react";
import classNames from "classnames";

import "./Button.css";

const Button = ({
  type,
  small,
  large,
  className,
  primary,
  children,
  ...props
}) => (
  <button
    type={type || "button"}
    className={classNames("Button", className, {
      "--large": large,
      "--small": small,
      "--primary": primary,
    })}
    {...props}
  >
    {children}
  </button>
);

export default Button;
